import React from "react";
import "./Icon.scss"

import {ReactComponent as userSvg} from "../../assets/user.svg";
import {ReactComponent as formsSvg} from "../../assets/Forms.svg";
import {ReactComponent as logoutSvg} from "../../assets/logout.svg";
import {ReactComponent as companySvg} from "../../assets/company.svg";
import {ReactComponent as customerSvg} from "../../assets/customers.svg";
import {ReactComponent as settingsSvg} from "../../assets/settings.svg";
import {ReactComponent as sentSvg} from "../../assets/sent.svg";
import {ReactComponent as separatorSvg} from "../../assets/separator.svg";
import {ReactComponent as documentSvg} from "../../assets/document.svg";
import { ReactComponent as plusSvg } from "../../assets/plus.svg";
import { ReactComponent as closeSvg } from "../../assets/close.svg";
import { ReactComponent as AlignTextCenterSvg } from "../../assets/textFormats/alignTextJustify.svg";
import { ReactComponent as AlignTextJustifySvg } from "../../assets/textFormats/alignTextCenter.svg";
import { ReactComponent as AlignTextLeftSvg } from "../../assets/textFormats/alignTextLeft.svg";
import { ReactComponent as AlignTextRightSvg } from "../../assets/textFormats/alignTextRight.svg";
import { ReactComponent as FormatBoldSvg } from "../../assets/textFormats/formatBold.svg";
import { ReactComponent as FormatColorSvg } from "../../assets/textFormats/formatColor.svg";
import { ReactComponent as FormatItalicSvg } from "../../assets/textFormats/formatItalic.svg";
import { ReactComponent as FormatListNumberedSvg } from "../../assets/textFormats/formatListNumbered.svg";
import { ReactComponent as FormatListBulletedSvg } from "../../assets/textFormats/formatListBulleted.svg";
import { ReactComponent as FormatUnderlineSvg } from "../../assets/textFormats/formatUnderline.svg";
import { ReactComponent as IndentSvg } from "../../assets/textFormats/indent.svg";
import {ReactComponent as LineHeightSvg} from "../../assets/textFormats/line-height.svg";
import { ReactComponent as AttachmentSvg } from "../../assets/attachment.svg";
import {ReactComponent as StatusSentSvg} from "../../assets/sent.svg";
import {ReactComponent as EditSvg} from "../../assets/edit.svg";
import {ReactComponent as TrashSvg} from "../../assets/trash.svg";
import {ReactComponent as eyeShowSvg} from "../../assets/eyeShow.svg";
import {ReactComponent as eyeHideSvg} from "../../assets/eyeHide.svg";
import {ReactComponent as emailSvg} from "../../assets/sent.svg";
import { ReactComponent as editFileSvg } from "../../assets/editFile.svg";
import {ReactComponent as edit2Svg} from "../../assets/edit2.svg";
import { ReactComponent as notSentSvg} from "../../assets/notSent.svg";
import { ReactComponent as returnedSvg} from "../../assets/returned.svg";
import { ReactComponent as signedSvg} from "../../assets/signed.svg";
import {ReactComponent as arrowSvg} from "../../assets/arrowdown.svg";
import {ReactComponent as CheckSvg} from "../../assets/check.svg";
import {ReactComponent as uploadSvg} from "../../assets/upload.svg";


export const userIcon = userSvg;
export const formsIcon = formsSvg;
export const logoutIcon = logoutSvg;
export const companyIcon = companySvg;
export const customerIcon = customerSvg;
export const settingsIcon = settingsSvg;
export const sentIcon = sentSvg;
export const separatorIcon = separatorSvg;
export const documentIcon = documentSvg;
export const plusIcon = plusSvg;
export const closeIcon = closeSvg;
export const alignTextCenterIcon = AlignTextCenterSvg;
export const alignTextJustifyIcon = AlignTextJustifySvg;
export const alignTextLeftIcon = AlignTextLeftSvg;
export const alignTextRightIcon = AlignTextRightSvg;
export const formatBoldIcon = FormatBoldSvg;
export const formatColorIcon = FormatColorSvg;
export const formatItalicIcon = FormatItalicSvg;
export const formatListNumberedIcon = FormatListNumberedSvg;
export const formatListBulletedIcon = FormatListBulletedSvg;
export const formatUnderlineIcon = FormatUnderlineSvg;
export const attachmentIcon = AttachmentSvg;
export const editIcon = EditSvg;
export const trashIcon = TrashSvg;
export const statusSentIcon = StatusSentSvg;
export const eyeShowIcon = eyeShowSvg;
export const eyeHideIcon = eyeHideSvg;
export const emailIcon = emailSvg;
export const editFileIcon = editFileSvg;
export const secondEditIcon = edit2Svg;
export const notSentIcon = notSentSvg;
export const returnedIcon = returnedSvg;
export const signedIcon = signedSvg;
export const arrowIcon = arrowSvg;
export const lineHeightIcon = LineHeightSvg;
export const indentIcon = IndentSvg;
export const checkIcon = CheckSvg;
export const uploadIcon = uploadSvg;

const Icon = ({svg, className, ...props}) => {
    return(
        <div {...props} className="icon">
            {React.createElement(svg, {className: className})}
        </div>
    )
}

export default Icon;